import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

const MAX_LENGTH = 255;
const MIN_LENGTH = 3;
const REGEX = /^\/?[a-z0-9/-]+$/;
const RESERVED_URLS = ['/admin', '/login', '/cart', '/checkout', '/api', '/account', '/settings'];

export function categoryUrlFormatValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    const value = control.value.trim();

    if (value.length > MAX_LENGTH) {
      return { urlTooLong: true };
    }

    if (value.endsWith('/') && value.length > 1) {
      return { urlTrailingSlash: true };
    }

    if (RESERVED_URLS.includes(value.toLowerCase())) {
      return { urlReserved: true };
    }

    const parts = value.split('/').filter((s: string) => s.length > 0);
    if (parts.length === 0) {
      return { urlInvalidStructure: true };
    }

    const slug = parts[parts.length - 1];
    if (slug.length < MIN_LENGTH) {
      return { urlSlugTooShort: true };
    }

    if (!REGEX.test(value)) {
      return { urlInvalidFormat: true };
    }

    if (value.includes('//') || value.includes('--')) {
      return { urlInvalidStructure: true };
    }

    return null;
  };
}
